

const state = {
    uid: uid,
    lng: {}
}

const getters = {
    uid: state => state.uid,
    lng: state => state.lng
}

const mutations = {
    setLng: (state, payload) => state.lng =  payload
}



const actions = {
    setLng: ({commit}, payload) => commit('setLng', payload)
}


export default {
    state, getters, mutations, actions
}


// WEBPACK FOOTER //
// ./vue/fleet/store/modules/general.js